import { Link } from "@inertiajs/react"
import { MessageSquare, Plus } from "lucide-react"

import { Button } from "@/components/ui/button"

// The whole-inbox empty state: no order or DM thread with a message, and no
// team chat. A customer can still have worked with freelancers (a chat-enabled
// order with a writer, nothing said yet), and the "New message" picker is how
// they start that first chat — so it is offered here too, not only above a
// populated list (UPDA-97).
export default function InboxEmptyState({ people = [], onCompose }) {
  return (
    <div className="flex h-[calc(100vh-69px)] min-h-[560px] flex-col items-center justify-center px-10 text-center max-[861px]:h-[calc(100dvh-69px)]">
      <div className="mb-[18px] grid size-[62px] place-items-center rounded-[17px] border border-border bg-secondary">
        <MessageSquare className="size-7 text-ink-3" strokeWidth={1.6} />
      </div>
      <h2 className="font-display text-lg font-bold tracking-[-0.3px]">No messages yet</h2>
      <p className="mt-2 max-w-[400px] text-[13.5px] leading-[1.55] text-ink-3">
        When you start a project, your conversation with the assigned team appears here — along with any direct messages
        with freelancers. Everything in one inbox.
      </p>
      <div className="mt-[22px] flex flex-wrap justify-center gap-2.5">
        {people.length > 0 && (
          <Button type="button" onClick={onCompose} className="gap-1.5 font-semibold">
            <Plus className="size-4" strokeWidth={2.2} />
            New message
          </Button>
        )}
        <Button asChild variant={people.length > 0 ? "outline" : "default"} className="gap-1.5 font-semibold">
          <Link href="/post">
            {people.length === 0 && <Plus className="size-4" strokeWidth={2.2} />}
            Post a project
          </Link>
        </Button>
        {/* Browse freelancers → the Hire / Find Freelancers screen. */}
        <Button asChild variant="outline" className="font-semibold">
          <Link href="/find-freelancers">Browse freelancers</Link>
        </Button>
      </div>
    </div>
  )
}
